module.exports = __webpack_public_path__ + "08dda1adc691c2c0a2a6fbd63301e38e.MP3";